import React from 'react';
import {Box, Typography} from '@mui/material';
import {ModalWrapper} from './ModalWrapper';
import {MuiModalTitle} from '@app/custom-mui-components';
import {useTranslation} from 'react-i18next';

export function VendorModal(props) {
	const {t} = useTranslation(['navBar']);

	const title = (
		<>
			<MuiModalTitle slightlybold="true">Roomgrid</MuiModalTitle>
			<hr />
			<Typography sx={{fontWeight: '500'}}>{t('vendorModal.applicationVendor')}</Typography>
		</>
	);

	const content = (
		<Box>
			<Box>
				<Box
					sx={{width: '195px', height: '128px'}}
					component="img"
					src="/assets/thoesch.png"
					alt="Thoesch logo"
				/>
			</Box>
			<Typography paragraph>Thoesch GmbH</Typography>
			<Typography paragraph>
				Mühlgasse 7
				<br />
				82335 Berg
				<br />
				Germany
			</Typography>
			<Typography paragraph>
				mail <a href="mailto:support@thoesch.com">support@thoesch.com</a>
				<br />
				web{' '}
				<a href="https://roomgrid.io" target="_blank" rel="noopener noreferrer">
					https://roomgrid.io
				</a>
			</Typography>
			<Typography paragraph>
				{t('vendorModal.registeredOffice')}: Berg
				<br />
				{t('vendorModal.registrationOffice')}: Amtsgericht München, HRB 188126
				<br />
				{t('vendorModal.managingDirector')}:  Bernhard Rieder, Lukas Schiller
				<br />
				{t('vendorModal.vatNr')}: DE275076590
			</Typography>
			<Typography sx={{wordWrap: 'break-word'}} paragraph>{`${t('vendorModal.version')}: ${
				window.VERS
			}`}</Typography>
		</Box>
	);

	return (
		<ModalWrapper title={title} content={content} open={props.open} onClose={props.onClose} />
	);
}
